import styled from "styled-components";

const QueueCardContainer = styled.div`
  width: 100%;
  padding: 8px 20px 8px 4px;
  cursor: pointer;
  &:hover {
    background: ${({ theme }) => theme.colors.lightGrey};
  }
`;

const QueueImageContainer = styled.div`
  width: 150px;
  height: 60px;
  overflow: hidden;
  border-radius: 6px;
`;

const QueueImage = styled.img`
  object-fit: cover;
  width: 100%;
  height: 100%;
`;

const QueueIconContainer = styled.div`
  width: 24px;
`;

export {
  QueueCardContainer,
  QueueImageContainer,
  QueueImage,
  QueueIconContainer,
};
